import axios from "../axiosInstance";
import type { GetLibraryTagsResponse } from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule.types";

/**
 * Fetch all unique tags used across library modules
 */
export const fetchLibraryTags = async (): Promise<GetLibraryTagsResponse> => {
  const response = await axios.get<GetLibraryTagsResponse>(
    "/api/learning-center/module-library/tags"
  );
  return response.data;
};

export default fetchLibraryTags;
